import api from "../../libs/api";

var __savedClickedIndex = -1;

angular
  .module("AccountingBoxApp")
  .controller("InboxCtrl", function(
    $scope,
    $rootScope,
    Attachment,
    LoopBackAuth,
    $state,
    $interval,
    $timeout,
  ) {
    var vm = this;
    vm.apiEndpoint = API_ENDPOINT;
    var uploads;
    $scope.currentCompany = $rootScope.currentCompany;

    vm.uploads = [];
    //
    let stop = $interval(function(){
      $timeout(function(){
        vm.refreshData();
      }, 1);
    }, 2.5*1000);

    // Cancel interval on page changes
    $scope.$on('$destroy', function() {
      $interval.cancel(stop);
    });

    vm.refreshData = async function() {
        const attachments = await api.get('/Attachments/inbox');
          let attachmentsOld = _.groupBy(vm.uploads, (a) => a.id)
          vm.uploads = attachments.map(a => ({
            ...(attachmentsOld[a.id] ? attachmentsOld[a.id][0] : {}),
            ...a
          }));
          vm.loading = false;
          $scope.$apply();
    };

    vm.loading = true;
    vm.refreshData().finally(() => {
      vm.loading = false;
      $scope.$apply();
    });

    vm.token = LoopBackAuth.accessTokenId;
    $scope.clickedIndex = __savedClickedIndex;
    vm.openProcessingScreen = function(upload) {
      $scope.clickedIndex = upload.id;
      __savedClickedIndex = upload.id;
      $rootScope.uploadIndex = vm.uploads.indexOf(upload);
      var processingScreen = "purchases";
      if (
        upload.transactionProposal &&
        upload.transactionProposal.transactionType
      ) {
        if (upload.transactionProposal.transactionType === "Sale") {
          processingScreen = "sales";
        } else if (
          upload.transactionProposal.transactionType === "JournalEntry"
        ) {
          processingScreen = "journalEntries";
        }
      }
      setTimeout(function() {
        $state.go("app.company.new." + processingScreen, {
          id: upload.id,
          attachment: upload
        });
      });
    };

    $scope.$on("closedUploadingModal", function() {
      // $timeout(function() {
      //   vm.refreshData();
      // }, 1000);
    });

    $scope.$on("uploadAdded", function(e, data) {
      var attachment = data.attachment;
      var type = data.file._file.type.slice(
        data.file._file.type.lastIndexOf("/") + 1
      );
      if (type !== "pdf") {
        attachment.justUploaded = true;
        attachment.file = data.file;
      } else {
        var index = vm.uploads.length;
        // setTimeout(function() {
        //   if(vm.uploads[index]) {
        //     vm.uploads[index].reload = true;
        //     $scope.$apply();
        //   }
        // }, 8000);
      }
      vm.uploads.push(data.attachment);
    });
  });
